module.exports = __webpack_public_path__ + "media/images/logos/stem-logo-white-988990abae4e537048c02c145f663a74.svg";